import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Plus,
  Calendar,
  ChevronDown,
  Star,
  ArrowRight,
  BarChart3,
  Users,
  Zap,
  Shield,
  CheckSquare
} from "lucide-react";
import "./TaskManagement.css";
import Footer from "../components/Footer";

export default function TaskManagement() {
  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);
  const toggleDarkMode = () => setDarkMode(!darkMode);

  const [tasks] = useState({
    pending: [
      { id: 1, title: "User FaRoy Chart", tags: ["Design", "Office"], date: "20 Mar", assignees: ["A", "B", "C"] },
      { id: 2, title: "Size Website", tags: ["Design", "Office"], date: "20 Mar", assignees: ["D", "E"] },
    ],
    inProgress: [
      { id: 3, title: "Urebsmar Chart", tags: ["Design", "Sales"], date: "20 Mar", assignees: ["F", "G", "H"] },
      { id: 4, title: "User Feor Dbite", tags: ["Design", "Enty"], date: "20 Mar", assignees: ["I", "J"] },
    ],
    review: [
      { id: 5, title: "Fix Bug in UI", tags: ["Hoozen", "Usot wder"], date: "20 Mar", assignees: ["K", "L"] },
      { id: 6, title: "Lonen Plan", tags: ["Hoozen", "Usot wder"], date: "31 Mar", assignees: ["M", "N", "O"] },
    ],
    completed: [
      { id: 7, title: "Creative in UI", tags: ["Nassign", "Dev", "Harvu"], date: "20 Mar", assignees: ["P"] },
      { id: 8, title: "Fictyprogresss", tags: ["Hoozen", "Usot wder"], date: "31 Mar", assignees: ["Q", "R"] },
    ],
  });



  return (
    <div className="task-management-page" style={{ fontFamily: "'DM Sans', 'Outfit', sans-serif" }}>
      {/* ══════════ NAVBAR ══════════ */}
      <nav className="navbar">
        <div className="logo-container" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          <svg className="product-icon" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 35 L45 35" stroke="#1E40AF" strokeWidth="4" strokeLinecap="round" />
            <path d="M20 50 L55 50" stroke="#14B8A6" strokeWidth="4" strokeLinecap="round" />
            <path d="M20 65 L65 65" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round" />
            <path d="M45 35 L55 40 L45 45 Z" fill="#1E40AF" />
            <path d="M55 50 L65 55 L55 60 Z" fill="#14B8A6" />
            <path d="M65 65 L75 70 L65 75 Z" fill="#F59E0B" />
            <circle cx="80" cy="50" r="8" fill="#1E40AF" />
          </svg>
          <span className="logo-text">SequFlow</span>
        </div>

        <ul>
          <li className="dropdown">
            Solutions ▾
            <div className="dropdown-menu">
              {["Enterprise", "Hybrid PM", "Construction", "Software Development", "Education", "Marketing", "Startup", "Testing", "Real Estate", "Consulting Services", "Manufacturing"].map(s => (
                <button key={s} onClick={(e) => e.preventDefault()} className="dropdown-item" style={{background:'transparent', border:'none', width:'100%', textAlign:'left', cursor:'pointer'}}>{s}</button>
              ))}
              <div className="dropdown-action">All Solutions</div>
            </div>
          </li>
          <li className="dropdown">
            Features ▾
            <div className="dropdown-menu">
              <button onClick={(e) => e.preventDefault()} className="dropdown-item" style={{background:'transparent', border:'none', width:'100%', textAlign:'left', cursor:'pointer'}}>Template Library <span className="badge-new">NEW</span></button>
              <button onClick={(e) => e.preventDefault()} className="dropdown-item" style={{background:'transparent', border:'none', width:'100%', textAlign:'left', cursor:'pointer'}}>Migrate from ›</button>
              {["Task Management", "Task Automation", "Blueprints", "Time Tracking", "Charts & Reporting", "Issue Tracking & SLA", "Team Collaboration", "Integrations", "Marketplace", "Mobile access", "Zia intelligence ✨"].map(f => (
                <button key={f} onClick={(e) => e.preventDefault()} className="dropdown-item" style={{background:'transparent', border:'none', width:'100%', textAlign:'left', cursor:'pointer'}}>{f}</button>
              ))}
              <div className="dropdown-action">All Features</div>
            </div>
          </li>
          <li>Customers</li>
          <li>Pricing</li>
          <li className="dropdown">
            Resources ▾
            <div className="dropdown-menu resources-menu">
              <div style={{ flex: 1 }}>
                <div className="dropdown-header">For Users</div>
                {["Knowledge Base", "Ebooks", "Community", "FAQs", "Webinars", "Help Videos", "What's New", "Blogs"].map(r => (
                  <button key={r} onClick={(e) => e.preventDefault()} className="dropdown-item" style={{background:'transparent', border:'none', width:'100%', textAlign:'left', cursor:'pointer'}}>{r}</button>
                ))}
              </div>
              <div style={{ flex: 1 }}>
                <div className="dropdown-header">For Developers</div>
                <button onClick={(e) => e.preventDefault()} className="dropdown-item" style={{background:'transparent', border:'none', width:'100%', textAlign:'left', cursor:'pointer'}}>API Guide</button>
                <button onClick={(e) => e.preventDefault()} className="dropdown-item" style={{background:'transparent', border:'none', width:'100%', textAlign:'left', cursor:'pointer'}}>Extension Guide</button>
                <div className="dropdown-divider" />
                <div className="dropdown-header">For Everyone</div>
                <button onClick={(e) => e.preventDefault()} className="dropdown-item" style={{background:'transparent', border:'none', width:'100%', textAlign:'left', cursor:'pointer'}}>The Productivity Compass</button>
                <button onClick={(e) => e.preventDefault()} className="dropdown-item" style={{background:'transparent', border:'none', width:'100%', textAlign:'left', cursor:'pointer'}}>Analyst Speak</button>
                <button onClick={(e) => e.preventDefault()} className="dropdown-item" style={{background:'transparent', border:'none', width:'100%', textAlign:'left', cursor:'pointer'}}>Partners</button>
              </div>
              <div className="dropdown-action" style={{ width: "100%" }}>All Resources</div>
            </div>
          </li>
          <li>Request a Demo</li>
        </ul>

        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <button onClick={toggleDarkMode} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "1.2rem" }} title="Toggle Dark Mode">
            {darkMode ? "☀️" : "🌙"}
          </button>
          <button className="nav-btn">Get Started</button>
        </div>
      </nav>

      {/* ══════════ HERO ══════════ */}
      <section className="hero-bg">
        <div style={{ maxWidth: 1280, margin: "0 auto", padding: "0 48px", position: "relative", zIndex: 2, width: "100%" }}>
          <div className="hero-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1.15fr", gap: 48, alignItems: "center" }}>
            <div className="animate-fade-up">
              <div style={{
                display: "inline-flex", alignItems: "center", gap: 8,
                background: "rgba(255,255,255,0.85)", backdropFilter: "blur(12px)",
                border: "1px solid rgba(255,255,255,0.9)",
                padding: "10px 20px", borderRadius: 50, marginBottom: 28,
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                fontWeight: 600, fontSize: "0.92rem", color: "#374151"
              }}>
                <span style={{ fontSize: "1.1rem" }}>⭐</span>
                New: AI-Powered Task Automation
              </div>

              <h1 style={{ fontSize: "clamp(2.6rem,5vw,3.8rem)", fontWeight: 900, lineHeight: 1.1, letterSpacing: "-1.5px", color: "#0f0a1e", marginBottom: 22 }}>
                Manage Tasks<br />Effectively
              </h1>

              <p style={{ fontSize: "1.13rem", color: "#475569", lineHeight: 1.7, marginBottom: 36, maxWidth: 500 }}>
                Break projects into milestones, track progress, collaborate with teams, and deliver work on time with our powerful task management system.
              </p>

              <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
                <button style={{
                  background: "#2c23d8",
                  color: "white", border: "none", padding: "14px 28px", borderRadius: 12,
                  fontWeight: 700, fontSize: "1rem", cursor: "pointer",
                  display: "flex", alignItems: "center", gap: 8,
                  boxShadow: "0 8px 24px rgba(44, 35, 216, 0.4)", transition: "all 0.3s",
                  fontFamily: "inherit"
                }}>
                  Access Task Manager <ArrowRight size={18} />
                </button>
                <button style={{
                  background: "rgba(255,255,255,0.85)", backdropFilter: "blur(12px)",
                  color: "#0f0a1e", border: "1.5px solid rgba(0,0,0,0.12)",
                  padding: "14px 28px", borderRadius: 12,
                  fontWeight: 600, fontSize: "1rem", cursor: "pointer", transition: "all 0.3s",
                  fontFamily: "inherit"
                }}>
                  Watch Demo
                </button>
              </div>
            </div>

            <div className="animate-fade-up delay-2" style={{ position: "relative" }}>
              <div style={{
                position: "absolute", top: "10%", left: "5%", right: "-5%", bottom: "-10%",
                background: "linear-gradient(135deg, rgba(44, 35, 216, 0.25), rgba(30, 64, 175, 0.15))",
                borderRadius: "50%", filter: "blur(60px)", zIndex: 0
              }} />
              <div style={{ position: "absolute", bottom: -40, left: 20, zIndex: 3, opacity: 0.85 }}>
                <div style={{ width: 100, height: 70, background: "linear-gradient(135deg, #10b981, #059669)", borderRadius: 12, transform: "perspective(400px) rotateX(20deg) rotateZ(-5deg)", boxShadow: "0 8px 20px rgba(16,185,129,0.4)" }} />
              </div>
              <div style={{ position: "absolute", bottom: -20, right: 30, zIndex: 3, opacity: 0.85 }}>
                <div style={{ width: 120, height: 50, background: "linear-gradient(135deg, #e2e8f0, #cbd5e1)", borderRadius: 10, transform: "perspective(400px) rotateX(20deg) rotateZ(3deg)", boxShadow: "0 6px 16px rgba(0,0,0,0.15)" }} />
              </div>

              <div className="browser-mockup browser-float" style={{ position: "relative", zIndex: 2 }}>
                <div className="browser-bar">
                  <div className="browser-dots">
                    <span style={{ background: "#ff5f57" }} />
                    <span style={{ background: "#ffbd2e" }} />
                    <span style={{ background: "#28c840" }} />
                  </div>
                  <div className="browser-url" />
                </div>

                <div style={{ background: "white", borderBottom: "1px solid #f0f0f0", padding: "10px 16px", display: "flex", alignItems: "center", gap: 16 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <svg width="20" height="20" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 35 L45 35" stroke="#1E40AF" strokeWidth="6" strokeLinecap="round" />
                      <path d="M20 50 L55 50" stroke="#14B8A6" strokeWidth="6" strokeLinecap="round" />
                      <path d="M20 65 L65 65" stroke="#F59E0B" strokeWidth="6" strokeLinecap="round" />
                      <path d="M45 35 L55 40 L45 45 Z" fill="#1E40AF" />
                      <path d="M55 50 L65 55 L55 60 Z" fill="#14B8A6" />
                      <path d="M65 65 L75 70 L65 75 Z" fill="#F59E0B" />
                      <circle cx="80" cy="50" r="7" fill="#1E40AF" />
                    </svg>
                    <span style={{ fontWeight: 800, fontSize: "0.8rem", background: "linear-gradient(135deg, #1E40AF, #14B8A6, #F59E0B)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>SequFlow</span>
                  </div>
                  {["Features", "Of dgets", "Featums", "Pricing", "Resources", "Demo"].map(m => (
                    <span key={m} style={{ fontSize: "0.7rem", color: "#64748b", fontWeight: 500 }}>{m}</span>
                  ))}
                  <button style={{
                    marginLeft: "auto", background: "#2c23d8",
                    color: "white", border: "none", padding: "5px 14px", borderRadius: 20,
                    fontSize: "0.7rem", fontWeight: 700, cursor: "pointer"
                  }}>Get Started</button>
                </div>

                <div style={{ padding: "14px 12px", background: "#fafafa", display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 10, minHeight: 340 }}>
                  {[
                    { key: "pending", label: "Pending", bg: "#f3e8ff", dot: "#a855f7" },
                    { key: "inProgress", label: "In Progress", bg: "#dbeafe", dot: "#3b82f6" },
                    { key: "review", label: "Review", bg: "#fce7f3", dot: "#ec4899" },
                    { key: "completed", label: "Completed", bg: "#dcfce7", dot: "#22c55e" },
                  ].map(col => (
                    <div key={col.key}>
                      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 8 }}>
                        <span style={{ width: 8, height: 8, borderRadius: "50%", background: col.dot, display: "inline-block" }} />
                        <span style={{ fontSize: "0.7rem", fontWeight: 700, color: "#1e293b" }}>{col.label}</span>
                        <ChevronDown size={10} style={{ marginLeft: "auto", color: "#94a3b8" }} />
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
                        {tasks[col.key].map(task => (
                          <div key={task.id} className="task-card">
                            <div style={{ fontSize: "0.68rem", fontWeight: 700, color: "#1e293b", marginBottom: 5, lineHeight: 1.3 }}>{task.title}</div>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 3, marginBottom: 7 }}>
                              {task.tags.slice(0, 2).map((tag, i) => (
                                <span key={i} style={{
                                  padding: "1px 6px", borderRadius: 4,
                                  fontSize: "0.58rem", fontWeight: 600,
                                  background: i === 0 ? "#f0fdf4" : "#f5f3ff",
                                  color: i === 0 ? "#16a34a" : "#7c3aed"
                                }}>{tag}</span>
                              ))}
                            </div>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                              <span style={{ fontSize: "0.6rem", color: "#64748b", display: "flex", alignItems: "center", gap: 3 }}>
                                <Calendar size={9} /> {task.date}
                              </span>
                              <div style={{ display: "flex" }}>
                                {task.assignees.slice(0, 3).map((a, i) => (
                                  <div key={i} style={{
                                    width: 16, height: 16, borderRadius: "50%",
                                    background: `hsl(${(i + task.id) * 60},65%,55%)`,
                                    border: "1.5px solid white", marginLeft: i ? -5 : 0,
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    fontSize: "0.45rem", color: "white", fontWeight: 700
                                  }}>{a}</div>
                                ))}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════ STATS ══════════ */}
      <section style={{ background: "white", padding: "64px 48px" }}>
        <div style={{ maxWidth: 1280, margin: "0 auto" }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", textAlign: "center", gap: 24 }}>
            {[
              { value: "10K+", label: "Active Users" },
              { value: "99.9%", label: "Uptime" },
              { value: "24/7", label: "Support" },
            ].map((s, i) => (
              <div key={i} style={{ padding: "24px 0" }}>
                <div style={{ fontSize: "clamp(2.5rem,5vw,3.5rem)", fontWeight: 900, background: "linear-gradient(135deg, #1e40af, #7c3aed)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", letterSpacing: "-1px" }}>{s.value}</div>
                <div style={{ fontSize: "1.05rem", color: "#64748b", fontWeight: 500, marginTop: 6 }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════ FEATURES ══════════ */}
      <section style={{ background: "#fafafa", padding: "96px 48px" }}>
        <div style={{ maxWidth: 1280, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 64 }}>
            <span style={{ background: "#f5f3ff", color: "#7c3aed", padding: "6px 16px", borderRadius: 50, fontSize: "0.85rem", fontWeight: 700, letterSpacing: "0.5px" }}>FEATURES</span>
            <h2 style={{ fontSize: "clamp(2rem,4vw,3rem)", fontWeight: 900, color: "#0f0a1e", marginTop: 16, letterSpacing: "-0.8px" }}>Powerful Features</h2>
            <p style={{ color: "#64748b", fontSize: "1.1rem", marginTop: 12 }}>Track, manage, and collaborate on all tasks in one place.</p>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))", gap: 24 }}>
            {[
              { icon: <CheckSquare size={32} color="#7c3aed" />, title: "Kanban Boards", desc: "Organize tasks visually and track workflow easily with drag-and-drop interface.", accent: "#f5f3ff" },
              { icon: <BarChart3 size={32} color="#3b82f6" />, title: "Gantt Charts", desc: "Plan timelines and manage dependencies smartly with powerful visualization.", accent: "#eff6ff" },
              { icon: <Users size={32} color="#10b981" />, title: "Team Collaboration", desc: "Assign tasks and communicate in real-time with your entire team.", accent: "#f0fdf4" },
            ].map((f, i) => (
              <div key={i} className="feature-card">
                <div style={{ width: 68, height: 68, background: f.accent, borderRadius: 18, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 24 }}>{f.icon}</div>
                <h3 style={{ fontSize: "1.25rem", fontWeight: 800, color: "#0f0a1e", marginBottom: 12, letterSpacing: "-0.3px" }}>{f.title}</h3>
                <p style={{ color: "#64748b", lineHeight: 1.65, marginBottom: 20 }}>{f.desc}</p>
                <button onClick={(e) => e.preventDefault()} style={{ background: "transparent", border: "none", color: "#7c3aed", fontWeight: 700, display: "flex", alignItems: "center", gap: 6, fontSize: "0.95rem", padding: 0, cursor: "pointer", fontFamily: "inherit" }}>
                  Learn More <ArrowRight size={16} />
                </button>
              </div>
            ))}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24, marginTop: 24 }}>
            <div style={{ background: "linear-gradient(135deg, #2c23d8 0%, #1e40af 100%)", borderRadius: 20, padding: "40px 36px", color: "white" }}>
              <Zap size={44} style={{ marginBottom: 16 }} />
              <h3 style={{ fontSize: "1.6rem", fontWeight: 800, marginBottom: 12, letterSpacing: "-0.4px" }}>Lightning Fast Performance</h3>
              <p style={{ color: "rgba(255,255,255,0.8)", lineHeight: 1.65 }}>Experience blazing fast load times and real-time updates across all your devices.</p>
            </div>
            <div style={{ background: "linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)", borderRadius: 20, padding: "40px 36px", color: "white" }}>
              <Shield size={44} style={{ marginBottom: 16 }} />
              <h3 style={{ fontSize: "1.6rem", fontWeight: 800, marginBottom: 12, letterSpacing: "-0.4px" }}>Enterprise-Grade Security</h3>
              <p style={{ color: "rgba(255,255,255,0.8)", lineHeight: 1.65 }}>Your data is protected with bank-level encryption and advanced security measures.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════ MILESTONES ══════════ */}
      <section style={{ background: "white", padding: "96px 48px" }}>
        <div style={{ maxWidth: 1280, margin: "0 auto" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1.1fr", gap: 72, alignItems: "center" }}>
            <div>
              <span style={{ background: "#f5f3ff", color: "#7c3aed", padding: "6px 16px", borderRadius: 50, fontSize: "0.85rem", fontWeight: 700 }}>MILESTONES</span>
              <h2 style={{ fontSize: "clamp(2rem,3.5vw,2.8rem)", fontWeight: 900, color: "#0f0a1e", marginTop: 16, marginBottom: 20, letterSpacing: "-0.8px" }}>Milestones</h2>
              <p style={{ fontSize: "1.08rem", color: "#475569", lineHeight: 1.75, marginBottom: 28 }}>
                A milestone is an important progress point along the timeline of your project that you need to pass as you move from start to finish. You can give your milestone a start and end date and assign a person responsible for its completion.
              </p>
              <button onClick={(e) => e.preventDefault()} style={{ background: "transparent", border: "none", color: "#7c3aed", fontWeight: 700, display: "inline-flex", alignItems: "center", gap: 6, fontSize: "1rem", padding: 0, cursor: "pointer", fontFamily: "inherit" }}>
                Learn more about Milestones <ArrowRight size={18} />
              </button>
            </div>

            <div style={{ background: "#f8f7ff", borderRadius: 20, border: "1px solid #ede9fe", overflow: "hidden" }}>
              <div style={{ padding: "12px 16px", background: "#f5f3ff", borderBottom: "1px solid #ede9fe", display: "grid", gridTemplateColumns: "1fr 60px 140px 100px", gap: 8 }}>
                {["Milestone", "%", "Owner", "Status"].map(h => (
                  <span key={h} style={{ fontSize: "0.75rem", fontWeight: 700, color: "#7c3aed", textTransform: "uppercase", letterSpacing: "0.5px" }}>{h}</span>
                ))}
              </div>
              {[
                { task: "Flooring", p: 33, owner: "Monica H", status: "Active" },
                { task: "Cleaning & walk-through", p: 48, owner: "Kavitha Raj", status: "Active" },
                { task: "Paint Work", p: 30, owner: "Monica H", status: "Active" },
                { task: "Insulation", p: 43, owner: "Steve Banks", status: "On Hold" },
                { task: "Flooring (Phase 2)", p: 44, owner: "Monica H", status: "In Progress" },
                { task: "Exterior Landscaping", p: 55, owner: "Steve Banks", status: "Active" },
                { task: "Roofing", p: 75, owner: "Lin Brenn", status: "Archived" },
                { task: "Plumbing Rough-in", p: 50, owner: "Lin Brenn", status: "Deferred" },
                { task: "Exterior Finishes", p: 100, owner: "Steve Banks", status: "Deferred" },
                { task: "Contracts & Agreements", p: 32, owner: "E. Vargas", status: "In Progress" },
                { task: "Hardware Installation", p: 38, owner: "Monica H", status: "On Hold" },
              ].map((item, idx) => {
                const statusColors = { "Active": "#16a34a", "On Hold": "#ea580c", "In Progress": "#2563eb", "Archived": "#6b7280", "Deferred": "#d97706" };
                const statusBgs = { "Active": "#dcfce7", "On Hold": "#ffedd5", "In Progress": "#dbeafe", "Archived": "#f3f4f6", "Deferred": "#fef3c7" };
                return (
                  <div key={idx} className="milestone-row" style={{ display: "grid", gridTemplateColumns: "1fr 60px 140px 100px", gap: 8, alignItems: "center" }}>
                    <span style={{ fontSize: "0.82rem", color: "#1e293b", fontWeight: 500 }}>{item.task}</span>
                    <span style={{ fontSize: "0.82rem", color: "#64748b", fontWeight: 600 }}>{item.p}%</span>
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <div style={{ width: 22, height: 22, borderRadius: "50%", background: `hsl(${idx * 37},60%,55%)`, flexShrink: 0 }} />
                      <span style={{ fontSize: "0.78rem", color: "#374151", fontWeight: 500 }}>{item.owner}</span>
                    </div>
                    <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: "0.72rem", fontWeight: 700, color: statusColors[item.status] || "#374151", background: statusBgs[item.status] || "#f3f4f6", display: "inline-block", textAlign: "center" }}>{item.status}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>


      {/* ══════════ KANBAN ══════════ */}
      <section style={{ background: "#f8f7ff", padding: "96px 48px" }}>
        <div style={{ maxWidth: 1280, margin: "0 auto" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1.1fr 1fr", gap: 72, alignItems: "center" }}>
            <div style={{ background: "white", borderRadius: 20, border: "1px solid #ede9fe", overflow: "hidden", boxShadow: "0 12px 40px rgba(124,58,237,0.1)" }}>
              <div style={{ padding: "12px 16px", background: "#f5f3ff", borderBottom: "1px solid #ede9fe", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontWeight: 700, fontSize: "0.85rem", color: "#7c3aed" }}>All Milestones</span>
                <button onClick={() => navigate('/tasks')} style={{ background: "#7c3aed", color: "white", border: "none", padding: "6px 14px", borderRadius: 20, fontSize: "0.78rem", fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", gap: 5, fontFamily: "inherit" }}>
                  <Plus size={13} /> Add Task
                </button>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 0 }}>
                {[
                  { label: "OPEN (11)", bg: "#06b6d4", cards: [{ id: "DC-110", title: "Set Roof trusses", sub: "Roof and Basement carpentry" }, { id: "DC-113", title: "Review sector A", sub: "Roof and basement carpentry" }, { id: "DC-1909", title: "Electrical Walk through", sub: "Walk through check list" }] },
                  { label: "IN PROGRESS (9)", bg: "#f59e0b", cards: [{ id: "DC-121", title: "Pour footings", sub: "Site plans", highlight: true }, { id: "DC-1838", title: "Electrical rough wire", sub: "Walk through check list" }, { id: "DC-1841", title: "Circuit system", sub: "General" }, { id: "DC-1127", title: "Termite treatment", sub: "Walk through check list" }] },
                  { label: "ANALYSIS (6)", bg: "#a855f7", cards: [{ id: "DC-1960", title: "Quality Check", sub: "Review All tasks" }, { id: "DC-1942", title: "Ceiling work", sub: "Walk-through check list" }, { id: "DC-15", title: "Set Roof trusses", sub: "" }, { id: "DC-1134", title: "Ledger Reports", sub: "Roof and Basement carpentry" }] },
                ].map(col => (
                  <div key={col.label} style={{ borderRight: "1px solid #f0f0f0", padding: 12 }}>
                    <div style={{ background: col.bg, color: "white", padding: "6px 12px", borderRadius: 8, fontSize: "0.72rem", fontWeight: 800, marginBottom: 10, textAlign: "center", letterSpacing: "0.3px" }}>{col.label}</div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                      {col.cards.map(card => (
                        <div key={card.id} style={{ background: card.highlight ? "#fffbeb" : "white", border: `1.5px solid ${card.highlight ? "#fbbf24" : "#f0f0f0"}`, borderRadius: 9, padding: "9px 10px", boxShadow: "0 1px 4px rgba(0,0,0,0.05)", transition: "all 0.2s", cursor: "pointer" }}>
                          <div style={{ fontSize: "0.62rem", fontWeight: 700, color: "#94a3b8", marginBottom: 3 }}>{card.id}</div>
                          <div style={{ fontSize: "0.72rem", fontWeight: 700, color: "#1e293b", marginBottom: card.sub ? 3 : 0, lineHeight: 1.3 }}>{card.title}</div>
                          {card.sub && <div style={{ fontSize: "0.64rem", color: "#94a3b8" }}>{card.sub}</div>}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <span style={{ background: "#eff6ff", color: "#3b82f6", padding: "6px 16px", borderRadius: 50, fontSize: "0.85rem", fontWeight: 700 }}>KANBAN</span>
              <h2 style={{ fontSize: "clamp(2rem,3.5vw,2.8rem)", fontWeight: 900, color: "#0f0a1e", marginTop: 16, marginBottom: 20, letterSpacing: "-0.8px" }}>Kanban</h2>
              <p style={{ fontSize: "1.08rem", color: "#475569", lineHeight: 1.75, marginBottom: 28 }}>
                The Kanban board helps you organize all your tasks as cards in different columns. These columns are based on different task criteria such as percentage completion or priority. Simply drag and drop tasks between columns to update its status quickly.
              </p>
              <button onClick={(e) => e.preventDefault()} style={{ background: "transparent", border: "none", color: "#3b82f6", fontWeight: 700, display: "inline-flex", alignItems: "center", gap: 6, fontSize: "1rem", padding: 0, cursor: "pointer", fontFamily: "inherit" }}>
                Learn more about Kanban <ArrowRight size={18} />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════ TESTIMONIALS ══════════ */}
      <section style={{ background: "white", padding: "96px 48px" }}>
        <div style={{ maxWidth: 1280, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 64 }}>
            <h2 style={{ fontSize: "clamp(2rem,4vw,3rem)", fontWeight: 900, color: "#0f0a1e", letterSpacing: "-0.8px" }}>Loved by Teams Worldwide</h2>
            <p style={{ color: "#64748b", fontSize: "1.1rem", marginTop: 12 }}>See what our customers have to say</p>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))", gap: 24 }}>
            {[
              { quote: "SequFlow has transformed how our team collaborates. The interface is intuitive and the features are exactly what we needed.", name: "Sarah Johnson", role: "Product Manager, TechCorp", color: "#7c3aed" },
              { quote: "Best task management tool we've used. The automation features save us hours every week and keep everything organized.", name: "Michael Chen", role: "CEO, StartupXYZ", color: "#3b82f6" },
              { quote: "The visual kanban boards make it so easy to see project status at a glance. Our productivity has increased by 40%!", name: "Emma Williams", role: "Design Lead, Creative Co", color: "#10b981" },
            ].map((t, i) => (
              <div key={i} style={{ background: "#fafafa", borderRadius: 20, padding: "32px 28px", border: "1px solid #f0f0f0" }}>
                <div style={{ display: "flex", gap: 3, marginBottom: 16 }}>
                  {[...Array(5)].map((_, j) => <Star key={j} size={18} style={{ fill: "#f59e0b", color: "#f59e0b" }} />)}
                </div>
                <p style={{ color: "#374151", lineHeight: 1.7, marginBottom: 24, fontSize: "0.97rem" }}>"{t.quote}"</p>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div style={{ width: 44, height: 44, borderRadius: "50%", background: `linear-gradient(135deg, ${t.color}, ${t.color}aa)` }} />
                  <div>
                    <div style={{ fontWeight: 800, fontSize: "0.95rem", color: "#0f0a1e" }}>{t.name}</div>
                    <div style={{ fontSize: "0.82rem", color: "#94a3b8" }}>{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════ CTA ══════════ */}
      <section style={{ padding: "80px 48px", background: "#fafafa" }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <div style={{
            background: "linear-gradient(135deg, #2c23d8 0%, #1e40af 100%)",
            borderRadius: 28, padding: "72px 48px", textAlign: "center", color: "white",
            position: "relative", overflow: "hidden",
            boxShadow: "0 30px 80px rgba(44, 35, 216, 0.35)"
          }}>
            <div style={{ position: "absolute", top: -60, right: -60, width: 200, height: 200, background: "rgba(255,255,255,0.08)", borderRadius: "50%" }} />
            <div style={{ position: "absolute", bottom: -40, left: -40, width: 160, height: 160, background: "rgba(255,255,255,0.06)", borderRadius: "50%" }} />
            <div style={{ position: "relative", zIndex: 1 }}>
              <h2 style={{ fontSize: "clamp(2rem,4vw,2.8rem)", fontWeight: 900, marginBottom: 16, letterSpacing: "-0.8px" }}>Start Managing Smarter Today</h2>
              <p style={{ color: "rgba(255,255,255,0.8)", fontSize: "1.1rem", marginBottom: 36, maxWidth: 500, margin: "0 auto 36px" }}>
                Join thousands of teams already using SequFlow to streamline their workflow.
              </p>
              <div style={{ display: "flex", gap: 14, justifyContent: "center" }}>
                <button style={{ background: "white", color: "#2c23d8", border: "none", padding: "16px 36px", borderRadius: 14, fontWeight: 800, fontSize: "1.05rem", cursor: "pointer", boxShadow: "0 8px 24px rgba(0,0,0,0.15)", fontFamily: "inherit" }}>
                  Try Now — It's Free
                </button>
                <button style={{ background: "transparent", color: "white", border: "2px solid rgba(255,255,255,0.5)", padding: "16px 36px", borderRadius: 14, fontWeight: 700, fontSize: "1.05rem", cursor: "pointer", fontFamily: "inherit" }}>
                  Contact Sales
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════ NEWSLETTER ══════════ */}


      <Footer />

    </div>
  );
}